import React from 'react';
import session from '../../../services/sessionService';
import {
  storeHistory,
  updateHistory,
  getHistory,
  getSocket,
  getScanners,
  isScanning,
  getResults,
} from 'services/testConnect';
import events from 'lib/events';
import TestConnectStatusService from '../../../services/tcStatusService';
import {FormattedMessage} from 'react-intl';
import {testConnectSidebarEnabled} from 'features';
import {getErrorCode, validNegativeErrorCodes} from 'services/errorCodes';

class TestConnectHistory extends React.Component {
  state = {
    history: [],
    retries: 3,
  };

  componentDidMount() {
    if (!testConnectSidebarEnabled) {
      return;
    }

    setTimeout(() => {
      this.updateHistory();
    }, 5000);

    let updateInterval = setInterval(() => {
      this.updateHistory();
    }, 15000);

    this.setState({
      updateInterval: updateInterval,
    });

    this._historyChangedListener = events.subscribe('testconnect.historyChanged', () => {
      this.updateHistory();
    });
  }

  componentWillUnmount() {
    this._historyChangedListener.remove();
  }

  updateHistory = () => {
    const {version} = TestConnectStatusService.getStatus();

    if (version >= '1.4.0') {
      getHistory()
        .then(d => {
          if (d.history && d.history.length > 0) {
            this.setState({
              history: d.history.filter(x => !x.data.errorMessage || typeof x.data.errorMessage !== 'object').reverse(),
            });

            let hasErrors = d.history.filter(h => h && typeof h !== 'object' && getErrorCode(h.data.errorMessage)).length > 0;

            this.setState({
              retries: 3,
            });

            TestConnectStatusService.setScanErrors(hasErrors);
          } else {
            if (this.state.updateInterval && this.state.retries === 0) {
              clearInterval(this.state.updateInterval);
              this.setState({
                updateInterval: null,
              });
            }

            this.setState({
              retries: this.state.retries - 1,
            }) ;
          }
        });
    }
  };

  viewUnusedScan = (history) => {
    let analysisState = history.data.state;

    analysisState.fromHistory = true;
    analysisState.initialAnalysis = history.analysis;
    session.persistAnalysis(analysisState);
    window.location.hash = `customer/${analysisState.customer.id}/${analysisState.pool.id}/analysis`;
    this.props.toggleTcOverlay();
    events.publish('testconnect.analysisChanged');
  };

  render() {
    let history = this.state.history.map(h => {
      let timeString = new Date(h.time).toLocaleTimeString();
      let errorStyle = {
        color: '#F90000',
      };


      let scanLink, scanName;

      if (h.data.saved) {
        scanLink = <a href={h.data.url.replace(/\/history/g, '')}><FormattedMessage id='tc-overlay.history.view-scan'/></a>;
        scanName = h.name;
      } else if (h.data.errorMessage) {
        scanLink = <p><FormattedMessage id='tc-overlay.history.help'/></p>;
        scanName = h.data.errorMessage;
      } else {
        scanLink = <a onClick={this.viewUnusedScan.bind(this, h)}><FormattedMessage id='tc-overlay.history.view-analysis'/></a>;
        scanName = <FormattedMessage id='tc-overlay.history.unused'/>;
      }

      return (
        <div className='tc-history'>
          <div className='row bold'>
            <div className='col-sm-6'>
              {h.scanner}
            </div>
            <div className='col-sm-6 right-align'>
              {timeString}
            </div>
          </div>
          <div className='row' style={h.data.errorMessage ? errorStyle : null}>
            <div className='col-sm-6'>
              {h.data.errorMessage && Number.isFinite(h.data.errorMessage) && (parseInt(h.data.errorMessage) > 0 || validNegativeErrorCodes.includes(parseInt(h.data.errorMessage))) && parseInt(h.data.errorMessage) < 1000 ?
                <FormattedMessage id='lamotte.error.message' values={{
                  code: scanName,
                  message: getErrorCode(scanName, 'SmartLab', false),
                }} /> :
                scanName}
            </div>
            <div className='col-sm-6 right-align'>
              {scanLink}
            </div>
          </div>
          <hr />
        </div>);
    });

    let noHistory = this.state.history.length === 0 ?
      <p className="centre"><FormattedMessage id='tc-overlay.history.no-scans'/></p> :
      '';

    return (
      <div className="history-container">
        {noHistory}
        {history}
      </div>);
  }
}

export default TestConnectHistory;
